export default "__VITE_ASSET__Ct38ueLl__"